import React, { useState, useEffect, useRef } from 'react';
import { Common } from '../../core/common';

type TooltipProps = {
  data: React.ReactNode;
  position?: 'top' | 'right' | 'bottom' | 'left';
  delay?: number;
  clickable?: boolean;
  backgroundColor?: string; // İsteğe bağlı arka plan rengi
  textColor?: string; // İsteğe bağlı yazı rengi
  maxWidthValue?: string;
  minWidthValue?: string;
  children: React.ReactNode;
  widthValue?: string;
  className?:string;

};

const Tooltip: React.FC<TooltipProps> = ({
  data,
  className='',
  position = 'top',
  delay = 0,
  clickable = false,
  backgroundColor = '#333', // Varsayılan arka plan rengi siyah
  textColor = '#fff', // Varsayılan yazı rengi beyaz
  maxWidthValue = "400px",
  widthValue = "unset",
  children
}) => {
  const [visible, setVisible] = useState(false);
  const [timeoutId, setTimeoutId] = useState<NodeJS.Timeout | null>(null);
  const tooltipRef = useRef<HTMLDivElement>(null);
  const _common = new Common();

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (clickable && tooltipRef.current && !tooltipRef.current.contains(event.target as Node)) {
        setVisible(false);
      }
    };

    if (clickable) {
      document.addEventListener('mousedown', handleClickOutside);
    }

    return () => {
      if (clickable) {
        document.removeEventListener('mousedown', handleClickOutside);
      }
    };
  }, [clickable]);

  const showTooltip = () => {
    const id = setTimeout(() => {
      setVisible(true);
    }, delay);
    setTimeoutId(id);
  };

  const hideTooltip = () => {
    if (timeoutId) clearTimeout(timeoutId);
    setVisible(false);
  };

  const toggleTooltip = () => {
    if (clickable) {
      setVisible(!visible);
    }
  };

  const getAnimationClass = (position: 'top' | 'right' | 'bottom' | 'left') => {
     switch (position) {
       case 'top':
         return 'fade-in-up';
       case 'right':
         return 'fade-in-right';
       case 'bottom':
         return 'fade-in-bottom';
       case 'left':
         return 'fade-in-left';
       default:
         return 'fade-in-up'; // Varsayılan animasyon 'top' olabilir
     }
   };

  return (
    <div
      className={`tooltip-wrapper ${className}`}
      onMouseEnter={!clickable ? showTooltip : undefined}
      onMouseLeave={!clickable ? hideTooltip : undefined}
      onClick={clickable ? toggleTooltip : undefined}
      ref={tooltipRef}
      style={{ position: 'relative', display: 'inline-block', width: `${widthValue}` }}
    >
      {children}
      {(visible && data) && (
        <div
          className={`tooltip-box tooltip-${position} ${visible ? getAnimationClass(position) : 'fade-out'}` + (!_common.isArabic(data.toString(), document.body.getAttribute('dir')) ? ' arabic-text-direction' : '')}
          style={{ backgroundColor, color: textColor, maxWidth: `${maxWidthValue}`, width: "max-content" }} // Dinamik stil eklemesi
        >
          {data}
          <div className={`tooltip-arrow tooltip-arrow-${position}`} />
        </div>
      )}
    </div>
  );
};

export default Tooltip;
